// extracted by mini-css-extract-plugin
export default {"box":"feedback_box__6LL2-","title":"feedback_title__CB2bI","field":"feedback_field__yA-6D"};